import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

export enum ReadsType {
  Raw,
  Processed
}

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [],
})
export class ScheduledModule {}
